export default function createBatteryStatusPayload({ charging, level } = {}) {
  let state = "UNKNOWN";
  if (charging) {
    state = "CHARGING";
  } else if (charging === false) {
    state = "DISCHARGING";
  }

  return { level: Math.round((level || 1) * 100), state };
}
